// Copy and data shared by the home page sections.
import { MONITOR_LOCATIONS } from '@/lib/check-locations'

export const browserPoints = [
  { title: 'Your Playwright scripts', desc: 'Log in, add to cart, check out — the flows pings can’t see. No new DSL.' },
  { title: 'A screenshot per step', desc: 'When a step breaks, you see exactly where, with a stepped replay.' },
  { title: 'Visual regression', desc: 'Each run is diffed against a baseline; a layout shift drops the score and alerts you.' },
]

export const showcase = [
  {
    title: MONITOR_LOCATIONS.showcase.title,
    desc: MONITOR_LOCATIONS.showcase.desc,
  },
  {
    title: 'Uptime you can read at 3am',
    desc: 'Thirty-second history with response-time percentiles. A degraded day stands out at a glance.',
  },
  {
    title: 'Alerts where your team looks',
    desc: 'Email, Slack, Discord and Telegram. One-click OAuth setup, with escalation policies and step-based routing.',
  },
]
